<template>
  <div class="modal_assembly">
    <el-dialog :title="obj.title" :visible.sync="obj.dialog" show-close :width="obj.width||'400px'"
      :before-close="cancel" close-on-click-modal>
      <el-form :model="obj.form" status-icon :ref="obj.ref">
        <div class="slot">
          <slot></slot>
        </div>
        <el-form-item class="btn_div">
          <el-button class="btn" @click="cancel()" v-if="!obj.hidCancel">{{obj.cancelText||"取消"}}</el-button>
          <el-button type="primary" class="btn" @click="submit()">{{obj.okText||"确定"}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: ["obj"],
    mounted() {},
    methods: {
      cancel() {
        this.$parent[this.obj.dialogText] = false
      },
      submit() {
        this.$emit("submit")
      }
    }

  }

</script>

<style lang="less">
  .modal_assembly {
    .el-dialog__header {
      border-bottom: 1px solid #DCDFE6;
    }

    .el-dialog__body {
      padding: 0px;

      .slot {
        padding: 10px 20px 20px 20px;
        max-height: 550px;
        overflow-y: auto;
      }

      .btn_div {
        text-align: right;
        padding: 5px 20px 10px 20px;
        border-top: 1px solid #DCDFE6;

        button {
          padding: 9px 14px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/modal.vue